import { useState } from 'react'
import { BusinessList } from '@/components/BusinessList'
import { BusinessDetail } from '@/components/BusinessDetail'
import { BusinessCreateForm } from '@/components/BusinessDetail/BusinessCreateForm'

type ViewMode = 'list' | 'detail' | 'create'

export function BusinessesPage() {
  const [viewMode, setViewMode] = useState<ViewMode>('list')
  const [selectedBusinessId, setSelectedBusinessId] = useState<string | null>(null)

  const handleBusinessSelect = (id: string) => {
    setSelectedBusinessId(id)
    setViewMode('detail')
  }

  const handleBack = () => {
    setSelectedBusinessId(null)
    setViewMode('list')
  }

  const handleCreateClick = () => {
    setViewMode('create')
  }

  const handleCreateSuccess = (id: string) => {
    setSelectedBusinessId(id)
    setViewMode('detail')
  }

  return (
    <div data-testid="businesses-page">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold text-gray-900">Businesses</h1>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        {viewMode === 'create' ? (
          <BusinessCreateForm
            onSuccess={handleCreateSuccess}
            onCancel={handleBack}
          />
        ) : viewMode === 'detail' && selectedBusinessId ? (
          <BusinessDetail businessId={selectedBusinessId} onBack={handleBack} />
        ) : (
          <BusinessList
            onBusinessSelect={handleBusinessSelect}
            onCreateClick={handleCreateClick}
          />
        )}
      </main>
    </div>
  )
}
